import * as Types from "./graphql";
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type FetchApplicantCvSummaryQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type FetchApplicantCvSummaryQuery = {
  __typename?: "Query";
  applicant?: {
    __typename?: "Applicant";
    id: string;
    protectedProfile?: {
      __typename?: "ListingApplicantProtectedProfile";
      candidateId: string;
      summaryId?: string | null;
      summary?: string | null;
    } | null;
  } | null;
};

export type FetchApplicantsListQueryVariables = Types.Exact<{
  filter: Types.ApplicantFilter;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;

export type FetchApplicantsListQuery = {
  __typename?: "Query";
  applicants: {
    __typename?: "ApplicantsResult";
    items: Array<{
      __typename?: "Applicant";
      id: string;
      rank?: number | null;
      name?: string | null;
      candidateId: string;
      isNew?: boolean | null;
      unsuccessful?: boolean | null;
      previouslyApplied: boolean;
      salaryMatch?: boolean | null;
      locationMatch?: boolean | null;
      preScreeningMatch?: boolean | null;
      applicationCreatedAt?: any | null;
      scores: {
        __typename?: "ApplicantScores";
        total?: number | null;
        qualifications?: number | null;
        skills?: number | null;
        assessments?: number | null;
      };
      location?: {
        __typename?: "ApplicantLocation";
        city?: string | null;
        state?: string | null;
        country?: string | null;
      } | null;
      hiredForListing?: { __typename?: "Listing"; id: string } | null;
      stage?: {
        __typename?: "ApplicationStage";
        id: string;
        name: string;
      } | null;
      status: { __typename?: "ApplicantStatus"; invited: boolean };
      profile?: {
        __typename?: "ApplicantProfile";
        cvId?: string | null;
        latestJob?: {
          __typename?: "ApplicantProfileJob";
          title?: string | null;
          company?: string | null;
        } | null;
        prePopulate?: {
          __typename?: "ApplicantProfilePrePopulate";
          isPrePopulated?: boolean | null;
          userConfirmed?: boolean | null;
        } | null;
      } | null;
      application?: {
        __typename?: "Application";
        id: string;
        unavailable: boolean;
        hired: boolean;
        isUnsuccessful: boolean;
        isNew: boolean;
        isActionPending: boolean;
        hiredForListing?: { __typename?: "Listing"; id: string } | null;
        stage?: {
          __typename?: "ApplicationStage";
          id: string;
          name: string;
        } | null;
        source: {
          __typename?: "ApplicationSource";
          referrerUrl?: any | null;
          name: string;
        };
      } | null;
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      page: number;
      pageSize: number;
      totalItems: number;
      totalPages: number;
    };
  };
};

export type FetchApplicantProfileQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type FetchApplicantProfileQuery = {
  __typename?: "Query";
  applicant?: {
    __typename?: "Applicant";
    id: string;
    rank?: number | null;
    listingId: string;
    candidateId: string;
    isDirect: boolean;
    previouslyApplied: boolean;
    name?: string | null;
    firstName?: string | null;
    locationMatch?: boolean | null;
    salaryMatch?: boolean | null;
    authorizedForWork?: boolean | null;
    isNew?: boolean | null;
    unsuccessful?: boolean | null;
    removed?: boolean | null;
    preScreeningMatch?: boolean | null;
    scores: {
      __typename?: "ApplicantScores";
      total?: number | null;
      qualifications?: number | null;
      skills?: number | null;
      assessments?: number | null;
    };
    location?: {
      __typename?: "ApplicantLocation";
      city?: string | null;
      state?: string | null;
      country?: string | null;
      match?: boolean | null;
    } | null;
    relocationLocations?: Array<{
      __typename?: "ApplicantRelocationLocation";
      city?: string | null;
      state?: string | null;
      country: string;
      authorized: boolean;
      match?: boolean | null;
    }> | null;
    hiredForListing?: { __typename?: "Listing"; id: string } | null;
    stage?: {
      __typename?: "ApplicationStage";
      id: string;
      name: string;
    } | null;
    status: { __typename?: "ApplicantStatus"; invited: boolean };
    preScreeningAnswers?: Array<{
      __typename?: "ApplicantPreScreeningAnswer";
      questionId: string;
      question?: string | null;
      answer: boolean;
      match: boolean;
    }> | null;
    skills?: {
      __typename?: "ApplicantSkills";
      jobs: Array<{
        __typename?: "ApplicantJob";
        title?: string | null;
        company?: string | null;
        startDate?: string | null;
        endDate?: string | null;
        skills: Array<{ __typename?: "Skill"; id: string; name: string }>;
      }>;
      skills?: {
        __typename?: "ApplicantMatchedSkills";
        requested: Array<{
          __typename?: "ApplicantRequestedSkill";
          importance?: number | null;
          requestedYears?: number | null;
          candidateYears?: number | null;
          skills: Array<{ __typename?: "Skill"; id: string; name: string }>;
        }>;
        workAreaMatch: Array<{
          __typename?: "ApplicantWorkAreaMatchSkill";
          candidateYears?: number | null;
          skill?: { __typename?: "Skill"; id: string; name: string } | null;
        }>;
        other: Array<{
          __typename?: "ApplicantOtherSkill";
          candidateYears?: number | null;
          skill?: { __typename?: "Skill"; id: string; name: string } | null;
        }>;
      } | null;
      workAreas?: {
        __typename?: "ApplicantWorkAreaLists";
        requested: Array<{
          __typename?: "ApplicantRequestedWorkArea";
          id?: string | null;
          match?: boolean | null;
          workArea?: {
            __typename?: "WorkArea";
            id: string;
            name: string;
          } | null;
        }>;
        other: Array<{
          __typename?: "ApplicantOtherWorkArea";
          id?: string | null;
          workArea?: {
            __typename?: "WorkArea";
            id: string;
            name: string;
          } | null;
        }>;
      } | null;
    } | null;
    qualifications?: {
      __typename?: "ApplicantQualifications";
      requested: Array<{
        __typename?: "ApplicantRequestedQualification";
        importance?: number | null;
        isMatch?: boolean | null;
        qualifications: Array<{
          __typename?: "Qualification";
          id: string;
          name: string;
        }>;
      }>;
      candidate: Array<{
        __typename?: "ApplicantCandidateQualification";
        institutionName?: string | null;
        completed?: boolean | null;
        startedAt?: string | null;
        completedAt?: string | null;
        studying?: boolean | null;
        qualification?: {
          __typename?: "Qualification";
          id: string;
          name: string;
        } | null;
        institution?: {
          __typename?: "Institution";
          id: string;
          name?: string | null;
        } | null;
      }>;
    } | null;
    assessments?: {
      __typename?: "ApplicantAssessments";
      cultureFit?: {
        __typename?: "ApplicantCultureFit";
        importance?: number | null;
        percentage?: number | null;
        comparisons: Array<{
          __typename?: "ApplicantCultureFitComparison";
          answer?: {
            __typename?: "ApplicantAssessmentAnswer";
            candidate?: number | null;
            listing?: number | null;
          } | null;
          label?: {
            __typename?: "ApplicantCultureFitLabel";
            left?: string | null;
            right?: string | null;
          } | null;
        }>;
      } | null;
      jobFit?: {
        __typename?: "ApplicantJobFit";
        importance?: number | null;
        percentage?: number | null;
        comparisons: Array<{
          __typename?: "ApplicantJobFitComparison";
          label?: string | null;
          answer?: {
            __typename?: "ApplicantAssessmentAnswer";
            candidate?: number | null;
            listing?: number | null;
          } | null;
        }>;
      } | null;
      personalityFit?: {
        __typename?: "ApplicantPersonalityFit";
        importance?: number | null;
        percentage?: number | null;
        personalityTypes?: {
          __typename?: "ApplicantPersonalityTypes";
          candidate: Array<string>;
          listing: Array<string>;
        } | null;
      } | null;
    } | null;
    application?: {
      __typename?: "Application";
      id: string;
      status: Types.ApplicationStatus;
      hired: boolean;
      unavailable: boolean;
      incomplete: boolean;
      isUnsuccessful: boolean;
      attachmentIds: Array<string>;
      hiredForListing?: { __typename?: "Listing"; id: string } | null;
      stage?: {
        __typename?: "ApplicationStage";
        id: string;
        name: string;
      } | null;
    } | null;
    profile?: {
      __typename?: "ApplicantProfile";
      cvId?: string | null;
      contactDetails?: {
        __typename?: "ApplicantProfileContactDetails";
        email?: string | null;
        phone1?: string | null;
      } | null;
      latestJob?: {
        __typename?: "ApplicantProfileJob";
        title?: string | null;
        company?: string | null;
      } | null;
      workPreferences?: {
        __typename?: "ApplicantProfileWorkPreferences";
        types?: Array<string | null> | null;
        remote?: boolean | null;
      } | null;
      professionalLinks?: Array<{
        __typename?: "ApplicantProfileProfessionalLink";
        url: string;
        label: string;
      } | null> | null;
      prePopulate?: {
        __typename?: "ApplicantProfilePrePopulate";
        isPrePopulated?: boolean | null;
        userConfirmed?: boolean | null;
      } | null;
    } | null;
    listing: {
      __typename?: "Listing";
      id: string;
      title?: string | null;
      applicationStages: Array<{
        __typename?: "ListingApplicationStage";
        id: string;
        name: string;
      }>;
      permissions?: {
        __typename?: "ListingPermissions";
        setStage: boolean;
        setStageToShortlistOnly: boolean;
        markAsHired: boolean;
        dropApplicants: boolean;
        viewMessages: boolean;
        inviteApplicants: boolean;
        viewAllNotes: boolean;
      } | null;
    };
  } | null;
};

export type FetchApplicantDocumentsQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type FetchApplicantDocumentsQuery = {
  __typename?: "Query";
  applicant?: {
    __typename?: "Applicant";
    id: string;
    candidateId: string;
    application?: {
      __typename?: "Application";
      id: string;
      previewAttachments?: Array<{
        __typename?: "ApplicantProfilePreviewAttachment";
        id: string;
        filename?: string | null;
        formats?: Array<{
          __typename?: "ApplicantProfilePreviewCvFormat";
          mimetype?: string | null;
          isOriginal?: boolean | null;
          downloadUrl?: string | null;
        }> | null;
      } | null> | null;
    } | null;
    profile?: {
      __typename?: "ApplicantProfile";
      previewCv?: {
        __typename?: "ApplicantProfilePreviewCvResult";
        id: string;
        filename?: string | null;
        formats?: Array<{
          __typename?: "ApplicantProfilePreviewCvFormat";
          mimetype?: string | null;
          isOriginal?: boolean | null;
          downloadUrl?: string | null;
        }> | null;
      } | null;
      previewAttachments?: Array<{
        __typename?: "ApplicantProfilePreviewAttachment";
        id: string;
        filename?: string | null;
        formats?: Array<{
          __typename?: "ApplicantProfilePreviewCvFormat";
          mimetype?: string | null;
          isOriginal?: boolean | null;
          downloadUrl?: string | null;
        }> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type FetchApplicantHistoryQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type FetchApplicantHistoryQuery = {
  __typename?: "Query";
  applicant?: {
    __typename?: "Applicant";
    id: string;
    applicationHistory: Array<{
      __typename?: "Application";
      id: string;
      createdAt: any;
      isUnsuccessful: boolean;
      hired: boolean;
      candidateId: string;
      hiredForListing?: { __typename?: "Listing"; id: string } | null;
      applicant?: { __typename?: "Applicant"; id: string } | null;
      stage?: {
        __typename?: "ApplicationStage";
        id: string;
        name: string;
      } | null;
      listing: {
        __typename?: "Listing";
        id: string;
        title?: string | null;
        permissions?: {
          __typename?: "ListingPermissions";
          view: boolean;
        } | null;
      };
    }>;
  } | null;
};

export type ApplicationsSetStageMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"];
  input: Types.ApplicationsSetStageInput;
}>;

export type ApplicationsSetStageMutation = {
  __typename?: "Mutation";
  applicationsSetStage: {
    __typename?: "BatchApplicationMutationResult";
    applications: Array<{
      __typename?: "Application";
      id: string;
      hired: boolean;
      isUnsuccessful: boolean;
      isNew: boolean;
      isActionPending: boolean;
      stage?: {
        __typename?: "ApplicationStage";
        id: string;
        name: string;
      } | null;
      hiredForListing?: { __typename?: "Listing"; id: string } | null;
    }>;
    errors: Array<{
      __typename?: "ApplicationMutationError";
      message: string;
      code: Types.ApplicationMutationErrorCode;
    }>;
  };
};

export type ApplicationHireMutationVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type ApplicationHireMutation = {
  __typename?: "Mutation";
  applicationHire: {
    __typename?: "ApplicationMutationResult";
    application?: {
      __typename?: "Application";
      id: string;
      hired: boolean;
      isUnsuccessful: boolean;
      isNew: boolean;
      isActionPending: boolean;
      stage?: {
        __typename?: "ApplicationStage";
        id: string;
        name: string;
      } | null;
      hiredForListing?: { __typename?: "Listing"; id: string } | null;
    } | null;
    errors: Array<{
      __typename?: "ApplicationMutationError";
      message: string;
      code: Types.ApplicationMutationErrorCode;
    }>;
  };
};

export type ApplicationsHireMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"];
}>;

export type ApplicationsHireMutation = {
  __typename?: "Mutation";
  applicationsHire: {
    __typename?: "BatchApplicationMutationResult";
    applications: Array<{
      __typename?: "Application";
      id: string;
      hired: boolean;
      isUnsuccessful: boolean;
      isNew: boolean;
      isActionPending: boolean;
      stage?: {
        __typename?: "ApplicationStage";
        id: string;
        name: string;
      } | null;
      hiredForListing?: { __typename?: "Listing"; id: string } | null;
    }>;
    errors: Array<{
      __typename?: "ApplicationMutationError";
      message: string;
      code: Types.ApplicationMutationErrorCode;
    }>;
  };
};

export type ApplicationMarkUnsuccessfulMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"];
}>;

export type ApplicationMarkUnsuccessfulMutation = {
  __typename?: "Mutation";
  applicationMarkUnsuccessful: {
    __typename?: "BatchApplicationMutationResult";
    applications: Array<{
      __typename?: "Application";
      id: string;
      hired: boolean;
      isUnsuccessful: boolean;
      isNew: boolean;
      isActionPending: boolean;
      stage?: {
        __typename?: "ApplicationStage";
        id: string;
        name: string;
      } | null;
      hiredForListing?: { __typename?: "Listing"; id: string } | null;
    }>;
    errors: Array<{
      __typename?: "ApplicationMutationError";
      message: string;
      code: Types.ApplicationMutationErrorCode;
    }>;
  };
};

export type ApplicationMarkSeenMutationVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type ApplicationMarkSeenMutation = {
  __typename?: "Mutation";
  applicationMarkSeen: {
    __typename?: "ApplicationMutationResult";
    application?: {
      __typename?: "Application";
      id: string;
      isNew: boolean;
    } | null;
    errors: Array<{
      __typename?: "ApplicationMutationError";
      message: string;
      code: Types.ApplicationMutationErrorCode;
    }>;
  };
};

export type ApplicantDropMutationVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type ApplicantDropMutation = {
  __typename?: "Mutation";
  applicantDrop: {
    __typename?: "ApplicantMutationResult";
    applicant?: { __typename?: "Applicant"; id: string } | null;
    errors: Array<{
      __typename?: "ApplicantMutationError";
      message: string;
      code: Types.ApplicantMutationErrorCode;
    }>;
  };
};

export type ApplicantsDropMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"];
}>;

export type ApplicantsDropMutation = {
  __typename?: "Mutation";
  applicantsDrop: {
    __typename?: "ApplicantsMutationResult";
    applicants: Array<{ __typename?: "Applicant"; id: string }>;
    errors: Array<{
      __typename?: "ApplicantMutationError";
      message: string;
      code: Types.ApplicantMutationErrorCode;
    }>;
  };
};

export type ApplicantInviteMutationVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type ApplicantInviteMutation = {
  __typename?: "Mutation";
  applicantInvite: {
    __typename?: "ApplicantMutationResult";
    applicant?: {
      __typename?: "Applicant";
      id: string;
      status: { __typename?: "ApplicantStatus"; invited: boolean };
    } | null;
    errors: Array<{
      __typename?: "ApplicantMutationError";
      message: string;
      code: Types.ApplicantMutationErrorCode;
    }>;
  };
};

export type FetchListingForApplicantsPageQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type FetchListingForApplicantsPageQuery = {
  __typename?: "Query";
  listing?: {
    __typename?: "Listing";
    id: string;
    slug?: string | null;
    title?: string | null;
    status: Types.ListingStatus;
    createdAt?: any | null;
    openedAt?: any | null;
    company?: string | null;
    processing?: boolean | null;
    isProcessingMatches: boolean;
    matchmakingFailed: boolean;
    team?: { __typename?: "Team"; id: string; name: string } | null;
    manager?: {
      __typename?: "User";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
    } | null;
    organisation: { __typename?: "Organisation"; id: string };
    owner?: {
      __typename?: "User";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
    } | null;
    scoreWeights?: {
      __typename?: "ListingScoreWeights";
      skills?: number | null;
      assessments?: number | null;
      qualifications?: number | null;
    } | null;
    locations: Array<{
      __typename?: "ListingLocation";
      locationId?: string | null;
      city?: string | null;
      state?: string | null;
      country: string;
    }>;
    applicationStages: Array<{
      __typename?: "ListingApplicationStage";
      id: string;
      name: string;
    }>;
    permissions?: {
      __typename?: "ListingPermissions";
      edit: boolean;
      viewApplicants: boolean;
      dropApplicants: boolean;
      inviteApplicants: boolean;
      setStage: boolean;
      setStageToShortlistOnly: boolean;
      markAsHired: boolean;
      createMessages: boolean;
      viewAllNotes: boolean;
      canAssignTag: boolean;
    } | null;
    sectionsCompleted: {
      __typename?: "ListingSectionsCompleted";
      prescreening: boolean;
    };
    applicantCounts: {
      __typename?: "ApplicantsCounts";
      total: number;
      direct: number;
      pool: number;
      new: number;
      actionPending: number;
      stages: Array<{
        __typename?: "ApplicantStageCount";
        stageId?: string | null;
        count: number;
      }>;
      completed: Array<{
        __typename?: "ApplicantCompletedCount";
        type: string;
        count: number;
      }>;
    };
  } | null;
};

export type FetchListingApplicantCountsQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type FetchListingApplicantCountsQuery = {
  __typename?: "Query";
  listing?: {
    __typename?: "Listing";
    id: string;
    applicantCounts: { __typename?: "ApplicantsCounts"; total: number };
  } | null;
};

export type FetchListingProcessingStatusQueryVariables = Types.Exact<{
  id: Types.Scalars["ID"]["input"];
}>;

export type FetchListingProcessingStatusQuery = {
  __typename?: "Query";
  listing?: {
    __typename?: "Listing";
    id: string;
    isProcessingMatches: boolean;
    matchmakingFailed: boolean;
  } | null;
};

export type ListingMatchmakingMarkPendingMutationVariables = Types.Exact<{
  listingId: Types.Scalars["ID"]["input"];
}>;

export type ListingMatchmakingMarkPendingMutation = {
  __typename?: "Mutation";
  listingMatchmakingMarkPending: {
    __typename?: "ListingMatchmakingMutationResult";
    listing?: {
      __typename?: "Listing";
      id: string;
      isProcessingMatches: boolean;
    } | null;
    errors: Array<{
      __typename?: "ListingMatchmakingMutationError";
      code: Types.ListingMatchmakingMutationErrorCode;
      message: string;
    }>;
  };
};

export type FetchDevelopPermissionsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type FetchDevelopPermissionsQuery = {
  __typename?: "Query";
  permissions?: {
    __typename?: "Permission";
    learningPortal?: boolean | null;
  } | null;
};

export type MyGroupMembersQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type MyGroupMembersQuery = {
  __typename?: "Query";
  myGroupMembers?: Array<{
    __typename?: "GroupMember";
    memberId: string;
    organisationId: string;
    groupId: string;
    memberType?: Types.MemberType | null;
    role?: Types.GroupRole | null;
    roleDisplayName?: string | null;
  } | null> | null;
};

export type GetHirePipelineListingsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ListingFilter>;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;

export type GetHirePipelineListingsQuery = {
  __typename?: "Query";
  listings: {
    __typename?: "ListingsResult";
    items: Array<{
      __typename?: "Listing";
      id: string;
      title?: string | null;
      applicantCounts: {
        __typename?: "ApplicantsCounts";
        new: number;
        actionPending: number;
        stages: Array<{
          __typename?: "ApplicantStageCount";
          stageId?: string | null;
          count: number;
        }>;
        completed: Array<{
          __typename?: "ApplicantCompletedCount";
          type: string;
          count: number;
        }>;
      };
    }>;
    pageInfo: {
      __typename?: "PageInfo";
      page: number;
      pageSize: number;
      totalItems: number;
      totalPages: number;
    };
  };
};

export type GetHirePipelineStageApplicantsQueryVariables = Types.Exact<{
  filter: Types.ApplicantFilter;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;

export type GetHirePipelineStageApplicantsQuery = {
  __typename?: "Query";
  applicants: {
    __typename?: "ApplicantsResult";
    items: Array<{
      __typename?: "Applicant";
      id: string;
      listingId: string;
      name?: string | null;
      applicationCreatedAt?: any | null;
      unsuccessful?: boolean | null;
      stage?: { __typename?: "ApplicationStage"; id: string } | null;
    }>;
    pageInfo: { __typename?: "PageInfo"; totalItems: number };
  };
};

export type UpdateListingScoreWeightsMutationVariables = Types.Exact<{
  listingId: Types.Scalars["ID"]["input"];
  input: Types.ListingScoreWeightsUpdateInput;
}>;

export type UpdateListingScoreWeightsMutation = {
  __typename?: "Mutation";
  listingScoreWeightsUpdate: {
    __typename?: "ListingScoreWeightsMutationResult";
    listingScoreWeights?: {
      __typename?: "ListingScoreWeights";
      skills?: number | null;
      assessments?: number | null;
      qualifications?: number | null;
    } | null;
    errors: Array<{
      __typename?: "ListingScoreWeightsMutationError";
      message: string;
      code: Types.ListingScoreWeightsMutationErrorCode;
    }>;
  };
};

export type GetMessageTemplatesQueryVariables = Types.Exact<{
  enabled?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type GetMessageTemplatesQuery = {
  __typename?: "Query";
  messageTemplates?: Array<{
    __typename?: "MessageTemplate";
    id?: string | null;
    organisationId?: string | null;
    name?: string | null;
    description?: string | null;
    subject?: string | null;
    content?: string | null;
    enabled?: boolean | null;
  } | null> | null;
};

export type TagActivityActionedByUserFieldsFragment = {
  __typename?: "TagActivityActionedByUser";
  timestamp?: any | null;
  user: {
    __typename?: "User";
    id: string;
    firstName?: string | null;
    lastName?: string | null;
  };
};

export type FetchTagActivitiesWithoutHistoryQueryVariables = Types.Exact<{
  filter: Types.TagActivityFilter;
}>;

export type FetchTagActivitiesWithoutHistoryQuery = {
  __typename?: "Query";
  tagActivities: Array<{
    __typename?: "TagActivity";
    id: string;
    action: Types.TagActivityAction;
    tag:
      | { __typename: "OrganisationTag"; id: string; label?: string | null }
      | { __typename: "SystemTag"; id: string };
    actionedByUser?: {
      __typename?: "TagActivityActionedByUser";
      timestamp?: any | null;
      user: {
        __typename?: "User";
        id: string;
        firstName?: string | null;
        lastName?: string | null;
      };
    } | null;
    targetApplicant?: { __typename?: "Applicant"; candidateId: string } | null;
  }>;
};

export type FetchOrganisationTagActivitiesQueryVariables = Types.Exact<{
  filter: Types.TagActivityFilter;
}>;

export type FetchOrganisationTagActivitiesQuery = {
  __typename?: "Query";
  tagActivities: Array<{
    __typename?: "TagActivity";
    id: string;
    notes?: string | null;
    action: Types.TagActivityAction;
    tag:
      | { __typename: "OrganisationTag"; id: string; label?: string | null }
      | { __typename: "SystemTag" };
    actionedByUser?: {
      __typename?: "TagActivityActionedByUser";
      timestamp?: any | null;
      user: {
        __typename?: "User";
        id: string;
        firstName?: string | null;
        lastName?: string | null;
      };
    } | null;
    targetApplicant?: { __typename?: "Applicant"; candidateId: string } | null;
  }>;
};

export type FetchApplicantTagActivitiesQueryVariables = Types.Exact<{
  filter: Types.TagActivityFilter;
}>;

export type FetchApplicantTagActivitiesQuery = {
  __typename?: "Query";
  tagActivities: Array<{
    __typename?: "TagActivity";
    id: string;
    action: Types.TagActivityAction;
    notes?: string | null;
    tag:
      | {
          __typename: "OrganisationTag";
          id: string;
          label?: string | null;
          assignedCount?: number | null;
        }
      | { __typename: "SystemTag"; id: string };
    actionedByUser?: {
      __typename?: "TagActivityActionedByUser";
      timestamp?: any | null;
      user: {
        __typename?: "User";
        id: string;
        firstName?: string | null;
        lastName?: string | null;
      };
    } | null;
    targetApplicant?: { __typename?: "Applicant"; candidateId: string } | null;
    history: Array<{
      __typename?: "TagActivityHistory";
      action: Types.TagActivityAction;
      notes?: string | null;
      actionedByUser?: {
        __typename?: "TagActivityActionedByUser";
        timestamp?: any | null;
        user: {
          __typename?: "User";
          id: string;
          firstName?: string | null;
          lastName?: string | null;
        };
      } | null;
    }>;
  }>;
};

export type FetchOrganisationTagsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type FetchOrganisationTagsQuery = {
  __typename?: "Query";
  organisationTags: Array<{
    __typename?: "OrganisationTag";
    id: string;
    label?: string | null;
    tagCategory?: string | null;
    assignedCount?: number | null;
  }>;
};

export type SystemTagActivitySetMutationVariables = Types.Exact<{
  input: Types.SystemTagActivityInput;
}>;

export type SystemTagActivitySetMutation = {
  __typename?: "Mutation";
  systemTagActivitySet?: {
    __typename?: "TagActivityMutationResult";
    tagActivity?: {
      __typename?: "TagActivity";
      id: string;
      action: Types.TagActivityAction;
      tag:
        | { __typename?: "OrganisationTag" }
        | { __typename?: "SystemTag"; id: string; label?: string | null };
      targetApplicant?: {
        __typename?: "Applicant";
        listingId: string;
        candidateId: string;
      } | null;
      actionedByUser?: {
        __typename?: "TagActivityActionedByUser";
        timestamp?: any | null;
        user: {
          __typename?: "User";
          id: string;
          firstName?: string | null;
          lastName?: string | null;
        };
      } | null;
    } | null;
    errors: Array<{ __typename?: "UserError"; message: string }>;
  } | null;
};

export type OrganisationTagCreateMutationVariables = Types.Exact<{
  input: Types.OrganisationTagCreateInput;
}>;

export type OrganisationTagCreateMutation = {
  __typename?: "Mutation";
  organisationTagCreate?: {
    __typename?: "OrganisationTagMutationResult";
    tag?:
      | { __typename: "OrganisationTag"; id: string; label?: string | null }
      | { __typename: "SystemTag" }
      | null;
    errors: Array<{
      __typename?: "CreateTagError";
      message?: string | null;
      code?: Types.CreateTagErrorCode | null;
    }>;
  } | null;
};

export type OrganisationTagActivitySetMutationVariables = Types.Exact<{
  input: Types.OrganisationTagActivityInput;
}>;

export type OrganisationTagActivitySetMutation = {
  __typename?: "Mutation";
  organisationTagActivitySet?: {
    __typename?: "OrganisationTagActivityMutationResult";
    tagActivities?: Array<{
      __typename?: "TagActivity";
      id: string;
      notes?: string | null;
      action: Types.TagActivityAction;
      tag:
        | { __typename?: "OrganisationTag"; id: string; label?: string | null }
        | { __typename?: "SystemTag"; id: string; label?: string | null };
      targetApplicant?: {
        __typename?: "Applicant";
        listingId: string;
        candidateId: string;
      } | null;
      actionedByUser?: {
        __typename?: "TagActivityActionedByUser";
        timestamp?: any | null;
        user: {
          __typename?: "User";
          id: string;
          firstName?: string | null;
          lastName?: string | null;
        };
      } | null;
    } | null> | null;
    errors: Array<{
      __typename?: "TagActivityMutationError";
      message?: string | null;
    }>;
  } | null;
};

export type DeleteOrganisationTagMutationVariables = Types.Exact<{
  input: Types.DeleteOrganisationTagInput;
}>;

export type DeleteOrganisationTagMutation = {
  __typename?: "Mutation";
  deleteOrganisationTag?: {
    __typename?: "DeleteOrganisationTagMutationResult";
    tag?: {
      __typename: "OrganisationTag";
      id: string;
      label?: string | null;
    } | null;
    errors?: Array<{
      __typename?: "DeleteOrganisationTagMutationError";
      message?: string | null;
    } | null> | null;
  } | null;
};

export type GetHirePipelineTagActivitiesQueryVariables = Types.Exact<{
  listingIds?: Types.InputMaybe<
    Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"]
  >;
}>;

export type GetHirePipelineTagActivitiesQuery = {
  __typename?: "Query";
  tagActivities: Array<{
    __typename?: "TagActivity";
    id: string;
    action: Types.TagActivityAction;
    targetApplicant?: {
      __typename?: "Applicant";
      id: string;
      candidateId: string;
      listingId: string;
      name?: string | null;
    } | null;
    tag:
      | { __typename?: "OrganisationTag"; id: string; label?: string | null }
      | { __typename?: "SystemTag"; id: string; label?: string | null };
  }>;
};

export type GetTeamMembersQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;

export type GetTeamMembersQuery = {
  __typename?: "Query";
  teams: {
    __typename?: "TeamsResult";
    items: Array<{
      __typename?: "Team";
      id: string;
      name: string;
      members: Array<{
        __typename?: "TeamMember";
        employer?: {
          __typename?: "User";
          id: string;
          firstName?: string | null;
          lastName?: string | null;
        } | null;
      }>;
    }>;
    pageInfo: { __typename?: "PageInfo"; totalPages: number };
  };
};

export type CreateUploadRequestMutationVariables = Types.Exact<{
  input: Types.CreateUploadRequestInput;
}>;

export type CreateUploadRequestMutation = {
  __typename?: "Mutation";
  createUploadRequest?: {
    __typename?: "UploadRequest";
    id: string;
    uploadUrl: string;
    downloadUrl: string;
  } | null;
};

export const TagActivityActionedByUserFieldsFragmentDoc = gql`
  fragment TagActivityActionedByUserFields on TagActivityActionedByUser {
    user {
      id
      firstName
      lastName
    }
    timestamp
  }
`;
export const FetchApplicantCvSummaryDocument = gql`
  query FetchApplicantCvSummary($id: ID!) {
    applicant(id: $id) {
      id
      protectedProfile {
        candidateId
        summaryId
        summary
      }
    }
  }
`;

/**
 * __useFetchApplicantCvSummaryQuery__
 *
 * To run a query within a React component, call `useFetchApplicantCvSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchApplicantCvSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchApplicantCvSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchApplicantCvSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchApplicantCvSummaryQuery,
    FetchApplicantCvSummaryQueryVariables
  > &
    (
      | { variables: FetchApplicantCvSummaryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchApplicantCvSummaryQuery,
    FetchApplicantCvSummaryQueryVariables
  >(FetchApplicantCvSummaryDocument, options);
}
export function useFetchApplicantCvSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchApplicantCvSummaryQuery,
    FetchApplicantCvSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchApplicantCvSummaryQuery,
    FetchApplicantCvSummaryQueryVariables
  >(FetchApplicantCvSummaryDocument, options);
}
// @ts-ignore
export function useFetchApplicantCvSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchApplicantCvSummaryQuery,
    FetchApplicantCvSummaryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchApplicantCvSummaryQuery,
  FetchApplicantCvSummaryQueryVariables
>;
export function useFetchApplicantCvSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchApplicantCvSummaryQuery,
        FetchApplicantCvSummaryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchApplicantCvSummaryQuery | undefined,
  FetchApplicantCvSummaryQueryVariables
>;
export function useFetchApplicantCvSummarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchApplicantCvSummaryQuery,
        FetchApplicantCvSummaryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchApplicantCvSummaryQuery,
    FetchApplicantCvSummaryQueryVariables
  >(FetchApplicantCvSummaryDocument, options);
}
export type FetchApplicantCvSummaryQueryHookResult = ReturnType<
  typeof useFetchApplicantCvSummaryQuery
>;
export type FetchApplicantCvSummaryLazyQueryHookResult = ReturnType<
  typeof useFetchApplicantCvSummaryLazyQuery
>;
export type FetchApplicantCvSummarySuspenseQueryHookResult = ReturnType<
  typeof useFetchApplicantCvSummarySuspenseQuery
>;
export type FetchApplicantCvSummaryQueryResult = Apollo.QueryResult<
  FetchApplicantCvSummaryQuery,
  FetchApplicantCvSummaryQueryVariables
>;
export const FetchApplicantsListDocument = gql`
  query FetchApplicantsList(
    $filter: ApplicantFilter!
    $pagination: Pagination
  ) {
    applicants(filter: $filter, pagination: $pagination) {
      items {
        id
        rank
        name
        candidateId
        isNew
        unsuccessful
        previouslyApplied
        salaryMatch
        locationMatch
        preScreeningMatch
        applicationCreatedAt
        scores {
          total
          qualifications
          skills
          assessments
        }
        location {
          city
          state
          country
        }
        hiredForListing {
          id
        }
        stage {
          id
          name
        }
        status {
          invited
        }
        profile {
          latestJob {
            title
            company
          }
          cvId
          prePopulate {
            isPrePopulated
            userConfirmed
          }
        }
        application {
          id
          unavailable
          hired
          isUnsuccessful
          isNew
          isActionPending
          hiredForListing {
            id
          }
          stage {
            id
            name
          }
          source {
            referrerUrl
            name
          }
        }
      }
      pageInfo {
        page
        pageSize
        totalItems
        totalPages
      }
    }
  }
`;

/**
 * __useFetchApplicantsListQuery__
 *
 * To run a query within a React component, call `useFetchApplicantsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchApplicantsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchApplicantsListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useFetchApplicantsListQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchApplicantsListQuery,
    FetchApplicantsListQueryVariables
  > &
    (
      | { variables: FetchApplicantsListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchApplicantsListQuery,
    FetchApplicantsListQueryVariables
  >(FetchApplicantsListDocument, options);
}
export function useFetchApplicantsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchApplicantsListQuery,
    FetchApplicantsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchApplicantsListQuery,
    FetchApplicantsListQueryVariables
  >(FetchApplicantsListDocument, options);
}
// @ts-ignore
export function useFetchApplicantsListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchApplicantsListQuery,
    FetchApplicantsListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchApplicantsListQuery,
  FetchApplicantsListQueryVariables
>;
export function useFetchApplicantsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchApplicantsListQuery,
        FetchApplicantsListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchApplicantsListQuery | undefined,
  FetchApplicantsListQueryVariables
>;
export function useFetchApplicantsListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchApplicantsListQuery,
        FetchApplicantsListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchApplicantsListQuery,
    FetchApplicantsListQueryVariables
  >(FetchApplicantsListDocument, options);
}
export type FetchApplicantsListQueryHookResult = ReturnType<
  typeof useFetchApplicantsListQuery
>;
export type FetchApplicantsListLazyQueryHookResult = ReturnType<
  typeof useFetchApplicantsListLazyQuery
>;
export type FetchApplicantsListSuspenseQueryHookResult = ReturnType<
  typeof useFetchApplicantsListSuspenseQuery
>;
export type FetchApplicantsListQueryResult = Apollo.QueryResult<
  FetchApplicantsListQuery,
  FetchApplicantsListQueryVariables
>;
export const FetchApplicantProfileDocument = gql`
  query FetchApplicantProfile($id: ID!) {
    applicant(id: $id) {
      id
      rank
      listingId
      candidateId
      isDirect
      previouslyApplied
      name
      firstName
      scores {
        total
        qualifications
        skills
        assessments
      }
      location {
        city
        state
        country
        match
      }
      locationMatch
      salaryMatch
      authorizedForWork
      relocationLocations {
        city
        state
        country
        authorized
        match
      }
      isNew
      unsuccessful
      removed
      hiredForListing {
        id
      }
      stage {
        id
        name
      }
      status {
        invited
      }
      preScreeningMatch
      preScreeningAnswers {
        questionId
        question
        answer
        match
      }
      skills {
        jobs {
          title
          company
          startDate
          endDate
          skills {
            id
            name
          }
        }
        skills {
          requested {
            skills {
              id
              name
            }
            importance
            requestedYears
            candidateYears
          }
          workAreaMatch {
            skill {
              id
              name
            }
            candidateYears
          }
          other {
            skill {
              id
              name
            }
            candidateYears
          }
        }
        workAreas {
          requested {
            id
            workArea {
              id
              name
            }
            match
          }
          other {
            id
            workArea {
              id
              name
            }
          }
        }
      }
      qualifications {
        requested {
          qualifications {
            id
            name
          }
          importance
          isMatch
        }
        candidate {
          qualification {
            id
            name
          }
          institution {
            id
            name
          }
          institutionName
          completed
          startedAt
          completedAt
          studying
        }
      }
      assessments {
        cultureFit {
          comparisons {
            answer {
              candidate
              listing
            }
            label {
              left
              right
            }
          }
          importance
          percentage
        }
        jobFit {
          comparisons {
            answer {
              candidate
              listing
            }
            label
          }
          importance
          percentage
        }
        personalityFit {
          importance
          percentage
          personalityTypes {
            candidate
            listing
          }
        }
      }
      application {
        id
        status
        hired
        unavailable
        incomplete
        isUnsuccessful
        hiredForListing {
          id
        }
        stage {
          id
          name
        }
        attachmentIds
      }
      profile {
        contactDetails {
          email
          phone1
        }
        latestJob {
          title
          company
        }
        workPreferences {
          types
          remote
        }
        cvId
        professionalLinks {
          url
          label
        }
        prePopulate {
          isPrePopulated
          userConfirmed
        }
      }
      listing {
        id
        title
        applicationStages {
          id
          name
        }
        permissions {
          setStage
          setStageToShortlistOnly
          markAsHired
          dropApplicants
          viewMessages
          inviteApplicants
          viewAllNotes
        }
      }
    }
  }
`;

/**
 * __useFetchApplicantProfileQuery__
 *
 * To run a query within a React component, call `useFetchApplicantProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchApplicantProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchApplicantProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchApplicantProfileQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchApplicantProfileQuery,
    FetchApplicantProfileQueryVariables
  > &
    (
      | { variables: FetchApplicantProfileQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchApplicantProfileQuery,
    FetchApplicantProfileQueryVariables
  >(FetchApplicantProfileDocument, options);
}
export function useFetchApplicantProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchApplicantProfileQuery,
    FetchApplicantProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchApplicantProfileQuery,
    FetchApplicantProfileQueryVariables
  >(FetchApplicantProfileDocument, options);
}
// @ts-ignore
export function useFetchApplicantProfileSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchApplicantProfileQuery,
    FetchApplicantProfileQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchApplicantProfileQuery,
  FetchApplicantProfileQueryVariables
>;
export function useFetchApplicantProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchApplicantProfileQuery,
        FetchApplicantProfileQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchApplicantProfileQuery | undefined,
  FetchApplicantProfileQueryVariables
>;
export function useFetchApplicantProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchApplicantProfileQuery,
        FetchApplicantProfileQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchApplicantProfileQuery,
    FetchApplicantProfileQueryVariables
  >(FetchApplicantProfileDocument, options);
}
export type FetchApplicantProfileQueryHookResult = ReturnType<
  typeof useFetchApplicantProfileQuery
>;
export type FetchApplicantProfileLazyQueryHookResult = ReturnType<
  typeof useFetchApplicantProfileLazyQuery
>;
export type FetchApplicantProfileSuspenseQueryHookResult = ReturnType<
  typeof useFetchApplicantProfileSuspenseQuery
>;
export type FetchApplicantProfileQueryResult = Apollo.QueryResult<
  FetchApplicantProfileQuery,
  FetchApplicantProfileQueryVariables
>;
export const FetchApplicantDocumentsDocument = gql`
  query FetchApplicantDocuments($id: ID!) {
    applicant(id: $id) {
      id
      candidateId
      application {
        id
        previewAttachments {
          id
          filename
          formats {
            mimetype
            isOriginal
            downloadUrl
          }
        }
      }
      profile {
        previewCv {
          id
          filename
          formats {
            mimetype
            isOriginal
            downloadUrl
          }
        }
        previewAttachments {
          id
          filename
          formats {
            mimetype
            isOriginal
            downloadUrl
          }
        }
      }
    }
  }
`;

/**
 * __useFetchApplicantDocumentsQuery__
 *
 * To run a query within a React component, call `useFetchApplicantDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchApplicantDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchApplicantDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchApplicantDocumentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchApplicantDocumentsQuery,
    FetchApplicantDocumentsQueryVariables
  > &
    (
      | { variables: FetchApplicantDocumentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchApplicantDocumentsQuery,
    FetchApplicantDocumentsQueryVariables
  >(FetchApplicantDocumentsDocument, options);
}
export function useFetchApplicantDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchApplicantDocumentsQuery,
    FetchApplicantDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchApplicantDocumentsQuery,
    FetchApplicantDocumentsQueryVariables
  >(FetchApplicantDocumentsDocument, options);
}
// @ts-ignore
export function useFetchApplicantDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchApplicantDocumentsQuery,
    FetchApplicantDocumentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchApplicantDocumentsQuery,
  FetchApplicantDocumentsQueryVariables
>;
export function useFetchApplicantDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchApplicantDocumentsQuery,
        FetchApplicantDocumentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchApplicantDocumentsQuery | undefined,
  FetchApplicantDocumentsQueryVariables
>;
export function useFetchApplicantDocumentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchApplicantDocumentsQuery,
        FetchApplicantDocumentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchApplicantDocumentsQuery,
    FetchApplicantDocumentsQueryVariables
  >(FetchApplicantDocumentsDocument, options);
}
export type FetchApplicantDocumentsQueryHookResult = ReturnType<
  typeof useFetchApplicantDocumentsQuery
>;
export type FetchApplicantDocumentsLazyQueryHookResult = ReturnType<
  typeof useFetchApplicantDocumentsLazyQuery
>;
export type FetchApplicantDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useFetchApplicantDocumentsSuspenseQuery
>;
export type FetchApplicantDocumentsQueryResult = Apollo.QueryResult<
  FetchApplicantDocumentsQuery,
  FetchApplicantDocumentsQueryVariables
>;
export const FetchApplicantHistoryDocument = gql`
  query FetchApplicantHistory($id: ID!) {
    applicant(id: $id) {
      id
      applicationHistory {
        id
        createdAt
        isUnsuccessful
        hired
        hiredForListing {
          id
        }
        candidateId
        applicant {
          id
        }
        stage {
          id
          name
        }
        listing {
          id
          title
          permissions {
            view
          }
        }
      }
    }
  }
`;

/**
 * __useFetchApplicantHistoryQuery__
 *
 * To run a query within a React component, call `useFetchApplicantHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchApplicantHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchApplicantHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchApplicantHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchApplicantHistoryQuery,
    FetchApplicantHistoryQueryVariables
  > &
    (
      | { variables: FetchApplicantHistoryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchApplicantHistoryQuery,
    FetchApplicantHistoryQueryVariables
  >(FetchApplicantHistoryDocument, options);
}
export function useFetchApplicantHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchApplicantHistoryQuery,
    FetchApplicantHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchApplicantHistoryQuery,
    FetchApplicantHistoryQueryVariables
  >(FetchApplicantHistoryDocument, options);
}
// @ts-ignore
export function useFetchApplicantHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchApplicantHistoryQuery,
    FetchApplicantHistoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchApplicantHistoryQuery,
  FetchApplicantHistoryQueryVariables
>;
export function useFetchApplicantHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchApplicantHistoryQuery,
        FetchApplicantHistoryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchApplicantHistoryQuery | undefined,
  FetchApplicantHistoryQueryVariables
>;
export function useFetchApplicantHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchApplicantHistoryQuery,
        FetchApplicantHistoryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchApplicantHistoryQuery,
    FetchApplicantHistoryQueryVariables
  >(FetchApplicantHistoryDocument, options);
}
export type FetchApplicantHistoryQueryHookResult = ReturnType<
  typeof useFetchApplicantHistoryQuery
>;
export type FetchApplicantHistoryLazyQueryHookResult = ReturnType<
  typeof useFetchApplicantHistoryLazyQuery
>;
export type FetchApplicantHistorySuspenseQueryHookResult = ReturnType<
  typeof useFetchApplicantHistorySuspenseQuery
>;
export type FetchApplicantHistoryQueryResult = Apollo.QueryResult<
  FetchApplicantHistoryQuery,
  FetchApplicantHistoryQueryVariables
>;
export const ApplicationsSetStageDocument = gql`
  mutation ApplicationsSetStage(
    $ids: [ID!]!
    $input: ApplicationsSetStageInput!
  ) {
    applicationsSetStage(ids: $ids, input: $input) {
      applications {
        id
        stage {
          id
          name
        }
        hired
        isUnsuccessful
        isNew
        isActionPending
        hiredForListing {
          id
        }
      }
      errors {
        message
        code
      }
    }
  }
`;
export type ApplicationsSetStageMutationFn = Apollo.MutationFunction<
  ApplicationsSetStageMutation,
  ApplicationsSetStageMutationVariables
>;

/**
 * __useApplicationsSetStageMutation__
 *
 * To run a mutation, you first call `useApplicationsSetStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationsSetStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationsSetStageMutation, { data, loading, error }] = useApplicationsSetStageMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplicationsSetStageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplicationsSetStageMutation,
    ApplicationsSetStageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplicationsSetStageMutation,
    ApplicationsSetStageMutationVariables
  >(ApplicationsSetStageDocument, options);
}
export type ApplicationsSetStageMutationHookResult = ReturnType<
  typeof useApplicationsSetStageMutation
>;
export type ApplicationsSetStageMutationResult =
  Apollo.MutationResult<ApplicationsSetStageMutation>;
export type ApplicationsSetStageMutationOptions = Apollo.BaseMutationOptions<
  ApplicationsSetStageMutation,
  ApplicationsSetStageMutationVariables
>;
export const ApplicationHireDocument = gql`
  mutation ApplicationHire($id: ID!) {
    applicationHire(id: $id) {
      application {
        id
        stage {
          id
          name
        }
        hired
        isUnsuccessful
        isNew
        isActionPending
        hiredForListing {
          id
        }
      }
      errors {
        message
        code
      }
    }
  }
`;
export type ApplicationHireMutationFn = Apollo.MutationFunction<
  ApplicationHireMutation,
  ApplicationHireMutationVariables
>;

/**
 * __useApplicationHireMutation__
 *
 * To run a mutation, you first call `useApplicationHireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationHireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationHireMutation, { data, loading, error }] = useApplicationHireMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationHireMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplicationHireMutation,
    ApplicationHireMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplicationHireMutation,
    ApplicationHireMutationVariables
  >(ApplicationHireDocument, options);
}
export type ApplicationHireMutationHookResult = ReturnType<
  typeof useApplicationHireMutation
>;
export type ApplicationHireMutationResult =
  Apollo.MutationResult<ApplicationHireMutation>;
export type ApplicationHireMutationOptions = Apollo.BaseMutationOptions<
  ApplicationHireMutation,
  ApplicationHireMutationVariables
>;
export const ApplicationsHireDocument = gql`
  mutation ApplicationsHire($ids: [ID!]!) {
    applicationsHire(ids: $ids) {
      applications {
        id
        stage {
          id
          name
        }
        hired
        isUnsuccessful
        isNew
        isActionPending
        hiredForListing {
          id
        }
      }
      errors {
        message
        code
      }
    }
  }
`;
export type ApplicationsHireMutationFn = Apollo.MutationFunction<
  ApplicationsHireMutation,
  ApplicationsHireMutationVariables
>;

/**
 * __useApplicationsHireMutation__
 *
 * To run a mutation, you first call `useApplicationsHireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationsHireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationsHireMutation, { data, loading, error }] = useApplicationsHireMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useApplicationsHireMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplicationsHireMutation,
    ApplicationsHireMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplicationsHireMutation,
    ApplicationsHireMutationVariables
  >(ApplicationsHireDocument, options);
}
export type ApplicationsHireMutationHookResult = ReturnType<
  typeof useApplicationsHireMutation
>;
export type ApplicationsHireMutationResult =
  Apollo.MutationResult<ApplicationsHireMutation>;
export type ApplicationsHireMutationOptions = Apollo.BaseMutationOptions<
  ApplicationsHireMutation,
  ApplicationsHireMutationVariables
>;
export const ApplicationMarkUnsuccessfulDocument = gql`
  mutation ApplicationMarkUnsuccessful($ids: [ID!]!) {
    applicationMarkUnsuccessful(ids: $ids) {
      applications {
        id
        stage {
          id
          name
        }
        hired
        isUnsuccessful
        isNew
        isActionPending
        hiredForListing {
          id
        }
      }
      errors {
        message
        code
      }
    }
  }
`;
export type ApplicationMarkUnsuccessfulMutationFn = Apollo.MutationFunction<
  ApplicationMarkUnsuccessfulMutation,
  ApplicationMarkUnsuccessfulMutationVariables
>;

/**
 * __useApplicationMarkUnsuccessfulMutation__
 *
 * To run a mutation, you first call `useApplicationMarkUnsuccessfulMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationMarkUnsuccessfulMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationMarkUnsuccessfulMutation, { data, loading, error }] = useApplicationMarkUnsuccessfulMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useApplicationMarkUnsuccessfulMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplicationMarkUnsuccessfulMutation,
    ApplicationMarkUnsuccessfulMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplicationMarkUnsuccessfulMutation,
    ApplicationMarkUnsuccessfulMutationVariables
  >(ApplicationMarkUnsuccessfulDocument, options);
}
export type ApplicationMarkUnsuccessfulMutationHookResult = ReturnType<
  typeof useApplicationMarkUnsuccessfulMutation
>;
export type ApplicationMarkUnsuccessfulMutationResult =
  Apollo.MutationResult<ApplicationMarkUnsuccessfulMutation>;
export type ApplicationMarkUnsuccessfulMutationOptions =
  Apollo.BaseMutationOptions<
    ApplicationMarkUnsuccessfulMutation,
    ApplicationMarkUnsuccessfulMutationVariables
  >;
export const ApplicationMarkSeenDocument = gql`
  mutation ApplicationMarkSeen($id: ID!) {
    applicationMarkSeen(id: $id) {
      application {
        id
        isNew
      }
      errors {
        message
        code
      }
    }
  }
`;
export type ApplicationMarkSeenMutationFn = Apollo.MutationFunction<
  ApplicationMarkSeenMutation,
  ApplicationMarkSeenMutationVariables
>;

/**
 * __useApplicationMarkSeenMutation__
 *
 * To run a mutation, you first call `useApplicationMarkSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationMarkSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationMarkSeenMutation, { data, loading, error }] = useApplicationMarkSeenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationMarkSeenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplicationMarkSeenMutation,
    ApplicationMarkSeenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplicationMarkSeenMutation,
    ApplicationMarkSeenMutationVariables
  >(ApplicationMarkSeenDocument, options);
}
export type ApplicationMarkSeenMutationHookResult = ReturnType<
  typeof useApplicationMarkSeenMutation
>;
export type ApplicationMarkSeenMutationResult =
  Apollo.MutationResult<ApplicationMarkSeenMutation>;
export type ApplicationMarkSeenMutationOptions = Apollo.BaseMutationOptions<
  ApplicationMarkSeenMutation,
  ApplicationMarkSeenMutationVariables
>;
export const ApplicantDropDocument = gql`
  mutation ApplicantDrop($id: ID!) {
    applicantDrop(id: $id) {
      applicant {
        id
      }
      errors {
        message
        code
      }
    }
  }
`;
export type ApplicantDropMutationFn = Apollo.MutationFunction<
  ApplicantDropMutation,
  ApplicantDropMutationVariables
>;

/**
 * __useApplicantDropMutation__
 *
 * To run a mutation, you first call `useApplicantDropMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicantDropMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicantDropMutation, { data, loading, error }] = useApplicantDropMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicantDropMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplicantDropMutation,
    ApplicantDropMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplicantDropMutation,
    ApplicantDropMutationVariables
  >(ApplicantDropDocument, options);
}
export type ApplicantDropMutationHookResult = ReturnType<
  typeof useApplicantDropMutation
>;
export type ApplicantDropMutationResult =
  Apollo.MutationResult<ApplicantDropMutation>;
export type ApplicantDropMutationOptions = Apollo.BaseMutationOptions<
  ApplicantDropMutation,
  ApplicantDropMutationVariables
>;
export const ApplicantsDropDocument = gql`
  mutation ApplicantsDrop($ids: [ID!]!) {
    applicantsDrop(ids: $ids) {
      applicants {
        id
      }
      errors {
        message
        code
      }
    }
  }
`;
export type ApplicantsDropMutationFn = Apollo.MutationFunction<
  ApplicantsDropMutation,
  ApplicantsDropMutationVariables
>;

/**
 * __useApplicantsDropMutation__
 *
 * To run a mutation, you first call `useApplicantsDropMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicantsDropMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicantsDropMutation, { data, loading, error }] = useApplicantsDropMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useApplicantsDropMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplicantsDropMutation,
    ApplicantsDropMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplicantsDropMutation,
    ApplicantsDropMutationVariables
  >(ApplicantsDropDocument, options);
}
export type ApplicantsDropMutationHookResult = ReturnType<
  typeof useApplicantsDropMutation
>;
export type ApplicantsDropMutationResult =
  Apollo.MutationResult<ApplicantsDropMutation>;
export type ApplicantsDropMutationOptions = Apollo.BaseMutationOptions<
  ApplicantsDropMutation,
  ApplicantsDropMutationVariables
>;
export const ApplicantInviteDocument = gql`
  mutation ApplicantInvite($id: ID!) {
    applicantInvite(id: $id) {
      applicant {
        id
        status {
          invited
        }
      }
      errors {
        message
        code
      }
    }
  }
`;
export type ApplicantInviteMutationFn = Apollo.MutationFunction<
  ApplicantInviteMutation,
  ApplicantInviteMutationVariables
>;

/**
 * __useApplicantInviteMutation__
 *
 * To run a mutation, you first call `useApplicantInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicantInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicantInviteMutation, { data, loading, error }] = useApplicantInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicantInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApplicantInviteMutation,
    ApplicantInviteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApplicantInviteMutation,
    ApplicantInviteMutationVariables
  >(ApplicantInviteDocument, options);
}
export type ApplicantInviteMutationHookResult = ReturnType<
  typeof useApplicantInviteMutation
>;
export type ApplicantInviteMutationResult =
  Apollo.MutationResult<ApplicantInviteMutation>;
export type ApplicantInviteMutationOptions = Apollo.BaseMutationOptions<
  ApplicantInviteMutation,
  ApplicantInviteMutationVariables
>;
export const FetchListingForApplicantsPageDocument = gql`
  query FetchListingForApplicantsPage($id: ID!) {
    listing(id: $id) {
      id
      slug
      title
      status
      createdAt
      openedAt
      company
      processing
      team {
        id
        name
      }
      manager {
        id
        firstName
        lastName
      }
      organisation {
        id
      }
      owner {
        id
        firstName
        lastName
      }
      scoreWeights {
        skills
        assessments
        qualifications
      }
      locations {
        locationId
        city
        state
        country
      }
      applicationStages {
        id
        name
      }
      permissions {
        edit
        viewApplicants
        dropApplicants
        inviteApplicants
        setStage
        setStageToShortlistOnly
        markAsHired
        createMessages
        viewAllNotes
        canAssignTag
      }
      sectionsCompleted {
        prescreening
      }
      applicantCounts {
        total
        direct
        pool
        new
        actionPending
        stages {
          stageId
          count
        }
        completed {
          type
          count
        }
      }
      isProcessingMatches
      matchmakingFailed
    }
  }
`;

/**
 * __useFetchListingForApplicantsPageQuery__
 *
 * To run a query within a React component, call `useFetchListingForApplicantsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchListingForApplicantsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchListingForApplicantsPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchListingForApplicantsPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchListingForApplicantsPageQuery,
    FetchListingForApplicantsPageQueryVariables
  > &
    (
      | {
          variables: FetchListingForApplicantsPageQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchListingForApplicantsPageQuery,
    FetchListingForApplicantsPageQueryVariables
  >(FetchListingForApplicantsPageDocument, options);
}
export function useFetchListingForApplicantsPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchListingForApplicantsPageQuery,
    FetchListingForApplicantsPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchListingForApplicantsPageQuery,
    FetchListingForApplicantsPageQueryVariables
  >(FetchListingForApplicantsPageDocument, options);
}
// @ts-ignore
export function useFetchListingForApplicantsPageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchListingForApplicantsPageQuery,
    FetchListingForApplicantsPageQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchListingForApplicantsPageQuery,
  FetchListingForApplicantsPageQueryVariables
>;
export function useFetchListingForApplicantsPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchListingForApplicantsPageQuery,
        FetchListingForApplicantsPageQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchListingForApplicantsPageQuery | undefined,
  FetchListingForApplicantsPageQueryVariables
>;
export function useFetchListingForApplicantsPageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchListingForApplicantsPageQuery,
        FetchListingForApplicantsPageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchListingForApplicantsPageQuery,
    FetchListingForApplicantsPageQueryVariables
  >(FetchListingForApplicantsPageDocument, options);
}
export type FetchListingForApplicantsPageQueryHookResult = ReturnType<
  typeof useFetchListingForApplicantsPageQuery
>;
export type FetchListingForApplicantsPageLazyQueryHookResult = ReturnType<
  typeof useFetchListingForApplicantsPageLazyQuery
>;
export type FetchListingForApplicantsPageSuspenseQueryHookResult = ReturnType<
  typeof useFetchListingForApplicantsPageSuspenseQuery
>;
export type FetchListingForApplicantsPageQueryResult = Apollo.QueryResult<
  FetchListingForApplicantsPageQuery,
  FetchListingForApplicantsPageQueryVariables
>;
export const FetchListingApplicantCountsDocument = gql`
  query FetchListingApplicantCounts($id: ID!) {
    listing(id: $id) {
      id
      applicantCounts {
        total
      }
    }
  }
`;

/**
 * __useFetchListingApplicantCountsQuery__
 *
 * To run a query within a React component, call `useFetchListingApplicantCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchListingApplicantCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchListingApplicantCountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchListingApplicantCountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchListingApplicantCountsQuery,
    FetchListingApplicantCountsQueryVariables
  > &
    (
      | { variables: FetchListingApplicantCountsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchListingApplicantCountsQuery,
    FetchListingApplicantCountsQueryVariables
  >(FetchListingApplicantCountsDocument, options);
}
export function useFetchListingApplicantCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchListingApplicantCountsQuery,
    FetchListingApplicantCountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchListingApplicantCountsQuery,
    FetchListingApplicantCountsQueryVariables
  >(FetchListingApplicantCountsDocument, options);
}
// @ts-ignore
export function useFetchListingApplicantCountsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchListingApplicantCountsQuery,
    FetchListingApplicantCountsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchListingApplicantCountsQuery,
  FetchListingApplicantCountsQueryVariables
>;
export function useFetchListingApplicantCountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchListingApplicantCountsQuery,
        FetchListingApplicantCountsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchListingApplicantCountsQuery | undefined,
  FetchListingApplicantCountsQueryVariables
>;
export function useFetchListingApplicantCountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchListingApplicantCountsQuery,
        FetchListingApplicantCountsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchListingApplicantCountsQuery,
    FetchListingApplicantCountsQueryVariables
  >(FetchListingApplicantCountsDocument, options);
}
export type FetchListingApplicantCountsQueryHookResult = ReturnType<
  typeof useFetchListingApplicantCountsQuery
>;
export type FetchListingApplicantCountsLazyQueryHookResult = ReturnType<
  typeof useFetchListingApplicantCountsLazyQuery
>;
export type FetchListingApplicantCountsSuspenseQueryHookResult = ReturnType<
  typeof useFetchListingApplicantCountsSuspenseQuery
>;
export type FetchListingApplicantCountsQueryResult = Apollo.QueryResult<
  FetchListingApplicantCountsQuery,
  FetchListingApplicantCountsQueryVariables
>;
export const FetchListingProcessingStatusDocument = gql`
  query FetchListingProcessingStatus($id: ID!) {
    listing(id: $id) {
      id
      isProcessingMatches
      matchmakingFailed
    }
  }
`;

/**
 * __useFetchListingProcessingStatusQuery__
 *
 * To run a query within a React component, call `useFetchListingProcessingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchListingProcessingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchListingProcessingStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchListingProcessingStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchListingProcessingStatusQuery,
    FetchListingProcessingStatusQueryVariables
  > &
    (
      | {
          variables: FetchListingProcessingStatusQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchListingProcessingStatusQuery,
    FetchListingProcessingStatusQueryVariables
  >(FetchListingProcessingStatusDocument, options);
}
export function useFetchListingProcessingStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchListingProcessingStatusQuery,
    FetchListingProcessingStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchListingProcessingStatusQuery,
    FetchListingProcessingStatusQueryVariables
  >(FetchListingProcessingStatusDocument, options);
}
// @ts-ignore
export function useFetchListingProcessingStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchListingProcessingStatusQuery,
    FetchListingProcessingStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchListingProcessingStatusQuery,
  FetchListingProcessingStatusQueryVariables
>;
export function useFetchListingProcessingStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchListingProcessingStatusQuery,
        FetchListingProcessingStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchListingProcessingStatusQuery | undefined,
  FetchListingProcessingStatusQueryVariables
>;
export function useFetchListingProcessingStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchListingProcessingStatusQuery,
        FetchListingProcessingStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchListingProcessingStatusQuery,
    FetchListingProcessingStatusQueryVariables
  >(FetchListingProcessingStatusDocument, options);
}
export type FetchListingProcessingStatusQueryHookResult = ReturnType<
  typeof useFetchListingProcessingStatusQuery
>;
export type FetchListingProcessingStatusLazyQueryHookResult = ReturnType<
  typeof useFetchListingProcessingStatusLazyQuery
>;
export type FetchListingProcessingStatusSuspenseQueryHookResult = ReturnType<
  typeof useFetchListingProcessingStatusSuspenseQuery
>;
export type FetchListingProcessingStatusQueryResult = Apollo.QueryResult<
  FetchListingProcessingStatusQuery,
  FetchListingProcessingStatusQueryVariables
>;
export const ListingMatchmakingMarkPendingDocument = gql`
  mutation ListingMatchmakingMarkPending($listingId: ID!) {
    listingMatchmakingMarkPending(listingId: $listingId) {
      listing {
        id
        isProcessingMatches
      }
      errors {
        code
        message
      }
    }
  }
`;
export type ListingMatchmakingMarkPendingMutationFn = Apollo.MutationFunction<
  ListingMatchmakingMarkPendingMutation,
  ListingMatchmakingMarkPendingMutationVariables
>;

/**
 * __useListingMatchmakingMarkPendingMutation__
 *
 * To run a mutation, you first call `useListingMatchmakingMarkPendingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useListingMatchmakingMarkPendingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [listingMatchmakingMarkPendingMutation, { data, loading, error }] = useListingMatchmakingMarkPendingMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useListingMatchmakingMarkPendingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ListingMatchmakingMarkPendingMutation,
    ListingMatchmakingMarkPendingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ListingMatchmakingMarkPendingMutation,
    ListingMatchmakingMarkPendingMutationVariables
  >(ListingMatchmakingMarkPendingDocument, options);
}
export type ListingMatchmakingMarkPendingMutationHookResult = ReturnType<
  typeof useListingMatchmakingMarkPendingMutation
>;
export type ListingMatchmakingMarkPendingMutationResult =
  Apollo.MutationResult<ListingMatchmakingMarkPendingMutation>;
export type ListingMatchmakingMarkPendingMutationOptions =
  Apollo.BaseMutationOptions<
    ListingMatchmakingMarkPendingMutation,
    ListingMatchmakingMarkPendingMutationVariables
  >;
export const FetchDevelopPermissionsDocument = gql`
  query FetchDevelopPermissions {
    permissions {
      learningPortal
    }
  }
`;

/**
 * __useFetchDevelopPermissionsQuery__
 *
 * To run a query within a React component, call `useFetchDevelopPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDevelopPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDevelopPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchDevelopPermissionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchDevelopPermissionsQuery,
    FetchDevelopPermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchDevelopPermissionsQuery,
    FetchDevelopPermissionsQueryVariables
  >(FetchDevelopPermissionsDocument, options);
}
export function useFetchDevelopPermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchDevelopPermissionsQuery,
    FetchDevelopPermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchDevelopPermissionsQuery,
    FetchDevelopPermissionsQueryVariables
  >(FetchDevelopPermissionsDocument, options);
}
// @ts-ignore
export function useFetchDevelopPermissionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchDevelopPermissionsQuery,
    FetchDevelopPermissionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchDevelopPermissionsQuery,
  FetchDevelopPermissionsQueryVariables
>;
export function useFetchDevelopPermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchDevelopPermissionsQuery,
        FetchDevelopPermissionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchDevelopPermissionsQuery | undefined,
  FetchDevelopPermissionsQueryVariables
>;
export function useFetchDevelopPermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchDevelopPermissionsQuery,
        FetchDevelopPermissionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchDevelopPermissionsQuery,
    FetchDevelopPermissionsQueryVariables
  >(FetchDevelopPermissionsDocument, options);
}
export type FetchDevelopPermissionsQueryHookResult = ReturnType<
  typeof useFetchDevelopPermissionsQuery
>;
export type FetchDevelopPermissionsLazyQueryHookResult = ReturnType<
  typeof useFetchDevelopPermissionsLazyQuery
>;
export type FetchDevelopPermissionsSuspenseQueryHookResult = ReturnType<
  typeof useFetchDevelopPermissionsSuspenseQuery
>;
export type FetchDevelopPermissionsQueryResult = Apollo.QueryResult<
  FetchDevelopPermissionsQuery,
  FetchDevelopPermissionsQueryVariables
>;
export const MyGroupMembersDocument = gql`
  query myGroupMembers {
    myGroupMembers {
      memberId
      organisationId
      groupId
      memberType
      role
      roleDisplayName
    }
  }
`;

/**
 * __useMyGroupMembersQuery__
 *
 * To run a query within a React component, call `useMyGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGroupMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyGroupMembersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyGroupMembersQuery,
    MyGroupMembersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyGroupMembersQuery, MyGroupMembersQueryVariables>(
    MyGroupMembersDocument,
    options,
  );
}
export function useMyGroupMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyGroupMembersQuery,
    MyGroupMembersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyGroupMembersQuery, MyGroupMembersQueryVariables>(
    MyGroupMembersDocument,
    options,
  );
}
// @ts-ignore
export function useMyGroupMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MyGroupMembersQuery,
    MyGroupMembersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  MyGroupMembersQuery,
  MyGroupMembersQueryVariables
>;
export function useMyGroupMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MyGroupMembersQuery,
        MyGroupMembersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  MyGroupMembersQuery | undefined,
  MyGroupMembersQueryVariables
>;
export function useMyGroupMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MyGroupMembersQuery,
        MyGroupMembersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MyGroupMembersQuery,
    MyGroupMembersQueryVariables
  >(MyGroupMembersDocument, options);
}
export type MyGroupMembersQueryHookResult = ReturnType<
  typeof useMyGroupMembersQuery
>;
export type MyGroupMembersLazyQueryHookResult = ReturnType<
  typeof useMyGroupMembersLazyQuery
>;
export type MyGroupMembersSuspenseQueryHookResult = ReturnType<
  typeof useMyGroupMembersSuspenseQuery
>;
export type MyGroupMembersQueryResult = Apollo.QueryResult<
  MyGroupMembersQuery,
  MyGroupMembersQueryVariables
>;
export const GetHirePipelineListingsDocument = gql`
  query GetHirePipelineListings(
    $filter: ListingFilter
    $pagination: Pagination
  ) {
    listings(filter: $filter, pagination: $pagination) {
      items {
        id
        title
        applicantCounts {
          new
          actionPending
          stages {
            stageId
            count
          }
          completed {
            type
            count
          }
        }
      }
      pageInfo {
        page
        pageSize
        totalItems
        totalPages
      }
    }
  }
`;

/**
 * __useGetHirePipelineListingsQuery__
 *
 * To run a query within a React component, call `useGetHirePipelineListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHirePipelineListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHirePipelineListingsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetHirePipelineListingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetHirePipelineListingsQuery,
    GetHirePipelineListingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetHirePipelineListingsQuery,
    GetHirePipelineListingsQueryVariables
  >(GetHirePipelineListingsDocument, options);
}
export function useGetHirePipelineListingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHirePipelineListingsQuery,
    GetHirePipelineListingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetHirePipelineListingsQuery,
    GetHirePipelineListingsQueryVariables
  >(GetHirePipelineListingsDocument, options);
}
// @ts-ignore
export function useGetHirePipelineListingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetHirePipelineListingsQuery,
    GetHirePipelineListingsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetHirePipelineListingsQuery,
  GetHirePipelineListingsQueryVariables
>;
export function useGetHirePipelineListingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetHirePipelineListingsQuery,
        GetHirePipelineListingsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetHirePipelineListingsQuery | undefined,
  GetHirePipelineListingsQueryVariables
>;
export function useGetHirePipelineListingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetHirePipelineListingsQuery,
        GetHirePipelineListingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetHirePipelineListingsQuery,
    GetHirePipelineListingsQueryVariables
  >(GetHirePipelineListingsDocument, options);
}
export type GetHirePipelineListingsQueryHookResult = ReturnType<
  typeof useGetHirePipelineListingsQuery
>;
export type GetHirePipelineListingsLazyQueryHookResult = ReturnType<
  typeof useGetHirePipelineListingsLazyQuery
>;
export type GetHirePipelineListingsSuspenseQueryHookResult = ReturnType<
  typeof useGetHirePipelineListingsSuspenseQuery
>;
export type GetHirePipelineListingsQueryResult = Apollo.QueryResult<
  GetHirePipelineListingsQuery,
  GetHirePipelineListingsQueryVariables
>;
export const GetHirePipelineStageApplicantsDocument = gql`
  query GetHirePipelineStageApplicants(
    $filter: ApplicantFilter!
    $pagination: Pagination
  ) {
    applicants(filter: $filter, pagination: $pagination) {
      items {
        id
        listingId
        name
        applicationCreatedAt
        stage {
          id
        }
        unsuccessful
      }
      pageInfo {
        totalItems
      }
    }
  }
`;

/**
 * __useGetHirePipelineStageApplicantsQuery__
 *
 * To run a query within a React component, call `useGetHirePipelineStageApplicantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHirePipelineStageApplicantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHirePipelineStageApplicantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetHirePipelineStageApplicantsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetHirePipelineStageApplicantsQuery,
    GetHirePipelineStageApplicantsQueryVariables
  > &
    (
      | {
          variables: GetHirePipelineStageApplicantsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetHirePipelineStageApplicantsQuery,
    GetHirePipelineStageApplicantsQueryVariables
  >(GetHirePipelineStageApplicantsDocument, options);
}
export function useGetHirePipelineStageApplicantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHirePipelineStageApplicantsQuery,
    GetHirePipelineStageApplicantsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetHirePipelineStageApplicantsQuery,
    GetHirePipelineStageApplicantsQueryVariables
  >(GetHirePipelineStageApplicantsDocument, options);
}
// @ts-ignore
export function useGetHirePipelineStageApplicantsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetHirePipelineStageApplicantsQuery,
    GetHirePipelineStageApplicantsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetHirePipelineStageApplicantsQuery,
  GetHirePipelineStageApplicantsQueryVariables
>;
export function useGetHirePipelineStageApplicantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetHirePipelineStageApplicantsQuery,
        GetHirePipelineStageApplicantsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetHirePipelineStageApplicantsQuery | undefined,
  GetHirePipelineStageApplicantsQueryVariables
>;
export function useGetHirePipelineStageApplicantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetHirePipelineStageApplicantsQuery,
        GetHirePipelineStageApplicantsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetHirePipelineStageApplicantsQuery,
    GetHirePipelineStageApplicantsQueryVariables
  >(GetHirePipelineStageApplicantsDocument, options);
}
export type GetHirePipelineStageApplicantsQueryHookResult = ReturnType<
  typeof useGetHirePipelineStageApplicantsQuery
>;
export type GetHirePipelineStageApplicantsLazyQueryHookResult = ReturnType<
  typeof useGetHirePipelineStageApplicantsLazyQuery
>;
export type GetHirePipelineStageApplicantsSuspenseQueryHookResult = ReturnType<
  typeof useGetHirePipelineStageApplicantsSuspenseQuery
>;
export type GetHirePipelineStageApplicantsQueryResult = Apollo.QueryResult<
  GetHirePipelineStageApplicantsQuery,
  GetHirePipelineStageApplicantsQueryVariables
>;
export const UpdateListingScoreWeightsDocument = gql`
  mutation UpdateListingScoreWeights(
    $listingId: ID!
    $input: ListingScoreWeightsUpdateInput!
  ) {
    listingScoreWeightsUpdate(listingId: $listingId, input: $input) {
      listingScoreWeights {
        skills
        assessments
        qualifications
      }
      errors {
        message
        code
      }
    }
  }
`;
export type UpdateListingScoreWeightsMutationFn = Apollo.MutationFunction<
  UpdateListingScoreWeightsMutation,
  UpdateListingScoreWeightsMutationVariables
>;

/**
 * __useUpdateListingScoreWeightsMutation__
 *
 * To run a mutation, you first call `useUpdateListingScoreWeightsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListingScoreWeightsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListingScoreWeightsMutation, { data, loading, error }] = useUpdateListingScoreWeightsMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateListingScoreWeightsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateListingScoreWeightsMutation,
    UpdateListingScoreWeightsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateListingScoreWeightsMutation,
    UpdateListingScoreWeightsMutationVariables
  >(UpdateListingScoreWeightsDocument, options);
}
export type UpdateListingScoreWeightsMutationHookResult = ReturnType<
  typeof useUpdateListingScoreWeightsMutation
>;
export type UpdateListingScoreWeightsMutationResult =
  Apollo.MutationResult<UpdateListingScoreWeightsMutation>;
export type UpdateListingScoreWeightsMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateListingScoreWeightsMutation,
    UpdateListingScoreWeightsMutationVariables
  >;
export const GetMessageTemplatesDocument = gql`
  query getMessageTemplates($enabled: Boolean) {
    messageTemplates(enabled: $enabled) {
      id
      organisationId
      name
      description
      subject
      content
      enabled
    }
  }
`;

/**
 * __useGetMessageTemplatesQuery__
 *
 * To run a query within a React component, call `useGetMessageTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageTemplatesQuery({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useGetMessageTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMessageTemplatesQuery,
    GetMessageTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetMessageTemplatesQuery,
    GetMessageTemplatesQueryVariables
  >(GetMessageTemplatesDocument, options);
}
export function useGetMessageTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMessageTemplatesQuery,
    GetMessageTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMessageTemplatesQuery,
    GetMessageTemplatesQueryVariables
  >(GetMessageTemplatesDocument, options);
}
// @ts-ignore
export function useGetMessageTemplatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMessageTemplatesQuery,
    GetMessageTemplatesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetMessageTemplatesQuery,
  GetMessageTemplatesQueryVariables
>;
export function useGetMessageTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMessageTemplatesQuery,
        GetMessageTemplatesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetMessageTemplatesQuery | undefined,
  GetMessageTemplatesQueryVariables
>;
export function useGetMessageTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMessageTemplatesQuery,
        GetMessageTemplatesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMessageTemplatesQuery,
    GetMessageTemplatesQueryVariables
  >(GetMessageTemplatesDocument, options);
}
export type GetMessageTemplatesQueryHookResult = ReturnType<
  typeof useGetMessageTemplatesQuery
>;
export type GetMessageTemplatesLazyQueryHookResult = ReturnType<
  typeof useGetMessageTemplatesLazyQuery
>;
export type GetMessageTemplatesSuspenseQueryHookResult = ReturnType<
  typeof useGetMessageTemplatesSuspenseQuery
>;
export type GetMessageTemplatesQueryResult = Apollo.QueryResult<
  GetMessageTemplatesQuery,
  GetMessageTemplatesQueryVariables
>;
export const FetchTagActivitiesWithoutHistoryDocument = gql`
  query FetchTagActivitiesWithoutHistory($filter: TagActivityFilter!) {
    tagActivities(filter: $filter) {
      id
      tag {
        __typename
        ... on SystemTag {
          id
        }
        ... on OrganisationTag {
          id
          label
        }
      }
      actionedByUser {
        ...TagActivityActionedByUserFields
      }
      action
      targetApplicant {
        candidateId
      }
    }
  }
  ${TagActivityActionedByUserFieldsFragmentDoc}
`;

/**
 * __useFetchTagActivitiesWithoutHistoryQuery__
 *
 * To run a query within a React component, call `useFetchTagActivitiesWithoutHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTagActivitiesWithoutHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTagActivitiesWithoutHistoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchTagActivitiesWithoutHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchTagActivitiesWithoutHistoryQuery,
    FetchTagActivitiesWithoutHistoryQueryVariables
  > &
    (
      | {
          variables: FetchTagActivitiesWithoutHistoryQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchTagActivitiesWithoutHistoryQuery,
    FetchTagActivitiesWithoutHistoryQueryVariables
  >(FetchTagActivitiesWithoutHistoryDocument, options);
}
export function useFetchTagActivitiesWithoutHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchTagActivitiesWithoutHistoryQuery,
    FetchTagActivitiesWithoutHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchTagActivitiesWithoutHistoryQuery,
    FetchTagActivitiesWithoutHistoryQueryVariables
  >(FetchTagActivitiesWithoutHistoryDocument, options);
}
// @ts-ignore
export function useFetchTagActivitiesWithoutHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchTagActivitiesWithoutHistoryQuery,
    FetchTagActivitiesWithoutHistoryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchTagActivitiesWithoutHistoryQuery,
  FetchTagActivitiesWithoutHistoryQueryVariables
>;
export function useFetchTagActivitiesWithoutHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchTagActivitiesWithoutHistoryQuery,
        FetchTagActivitiesWithoutHistoryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchTagActivitiesWithoutHistoryQuery | undefined,
  FetchTagActivitiesWithoutHistoryQueryVariables
>;
export function useFetchTagActivitiesWithoutHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchTagActivitiesWithoutHistoryQuery,
        FetchTagActivitiesWithoutHistoryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchTagActivitiesWithoutHistoryQuery,
    FetchTagActivitiesWithoutHistoryQueryVariables
  >(FetchTagActivitiesWithoutHistoryDocument, options);
}
export type FetchTagActivitiesWithoutHistoryQueryHookResult = ReturnType<
  typeof useFetchTagActivitiesWithoutHistoryQuery
>;
export type FetchTagActivitiesWithoutHistoryLazyQueryHookResult = ReturnType<
  typeof useFetchTagActivitiesWithoutHistoryLazyQuery
>;
export type FetchTagActivitiesWithoutHistorySuspenseQueryHookResult =
  ReturnType<typeof useFetchTagActivitiesWithoutHistorySuspenseQuery>;
export type FetchTagActivitiesWithoutHistoryQueryResult = Apollo.QueryResult<
  FetchTagActivitiesWithoutHistoryQuery,
  FetchTagActivitiesWithoutHistoryQueryVariables
>;
export const FetchOrganisationTagActivitiesDocument = gql`
  query FetchOrganisationTagActivities($filter: TagActivityFilter!) {
    tagActivities(filter: $filter) {
      id
      tag {
        __typename
        ... on OrganisationTag {
          id
          label
        }
      }
      actionedByUser {
        ...TagActivityActionedByUserFields
      }
      notes
      action
      targetApplicant {
        candidateId
      }
    }
  }
  ${TagActivityActionedByUserFieldsFragmentDoc}
`;

/**
 * __useFetchOrganisationTagActivitiesQuery__
 *
 * To run a query within a React component, call `useFetchOrganisationTagActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOrganisationTagActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOrganisationTagActivitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchOrganisationTagActivitiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchOrganisationTagActivitiesQuery,
    FetchOrganisationTagActivitiesQueryVariables
  > &
    (
      | {
          variables: FetchOrganisationTagActivitiesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchOrganisationTagActivitiesQuery,
    FetchOrganisationTagActivitiesQueryVariables
  >(FetchOrganisationTagActivitiesDocument, options);
}
export function useFetchOrganisationTagActivitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchOrganisationTagActivitiesQuery,
    FetchOrganisationTagActivitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchOrganisationTagActivitiesQuery,
    FetchOrganisationTagActivitiesQueryVariables
  >(FetchOrganisationTagActivitiesDocument, options);
}
// @ts-ignore
export function useFetchOrganisationTagActivitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchOrganisationTagActivitiesQuery,
    FetchOrganisationTagActivitiesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchOrganisationTagActivitiesQuery,
  FetchOrganisationTagActivitiesQueryVariables
>;
export function useFetchOrganisationTagActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchOrganisationTagActivitiesQuery,
        FetchOrganisationTagActivitiesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchOrganisationTagActivitiesQuery | undefined,
  FetchOrganisationTagActivitiesQueryVariables
>;
export function useFetchOrganisationTagActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchOrganisationTagActivitiesQuery,
        FetchOrganisationTagActivitiesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchOrganisationTagActivitiesQuery,
    FetchOrganisationTagActivitiesQueryVariables
  >(FetchOrganisationTagActivitiesDocument, options);
}
export type FetchOrganisationTagActivitiesQueryHookResult = ReturnType<
  typeof useFetchOrganisationTagActivitiesQuery
>;
export type FetchOrganisationTagActivitiesLazyQueryHookResult = ReturnType<
  typeof useFetchOrganisationTagActivitiesLazyQuery
>;
export type FetchOrganisationTagActivitiesSuspenseQueryHookResult = ReturnType<
  typeof useFetchOrganisationTagActivitiesSuspenseQuery
>;
export type FetchOrganisationTagActivitiesQueryResult = Apollo.QueryResult<
  FetchOrganisationTagActivitiesQuery,
  FetchOrganisationTagActivitiesQueryVariables
>;
export const FetchApplicantTagActivitiesDocument = gql`
  query FetchApplicantTagActivities($filter: TagActivityFilter!) {
    tagActivities(filter: $filter) {
      id
      tag {
        __typename
        ... on SystemTag {
          id
        }
        ... on OrganisationTag {
          id
          label
          assignedCount
        }
      }
      actionedByUser {
        ...TagActivityActionedByUserFields
      }
      action
      notes
      targetApplicant {
        candidateId
      }
      history {
        action
        actionedByUser {
          ...TagActivityActionedByUserFields
        }
        notes
      }
    }
  }
  ${TagActivityActionedByUserFieldsFragmentDoc}
`;

/**
 * __useFetchApplicantTagActivitiesQuery__
 *
 * To run a query within a React component, call `useFetchApplicantTagActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchApplicantTagActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchApplicantTagActivitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFetchApplicantTagActivitiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    FetchApplicantTagActivitiesQuery,
    FetchApplicantTagActivitiesQueryVariables
  > &
    (
      | { variables: FetchApplicantTagActivitiesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchApplicantTagActivitiesQuery,
    FetchApplicantTagActivitiesQueryVariables
  >(FetchApplicantTagActivitiesDocument, options);
}
export function useFetchApplicantTagActivitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchApplicantTagActivitiesQuery,
    FetchApplicantTagActivitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchApplicantTagActivitiesQuery,
    FetchApplicantTagActivitiesQueryVariables
  >(FetchApplicantTagActivitiesDocument, options);
}
// @ts-ignore
export function useFetchApplicantTagActivitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchApplicantTagActivitiesQuery,
    FetchApplicantTagActivitiesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchApplicantTagActivitiesQuery,
  FetchApplicantTagActivitiesQueryVariables
>;
export function useFetchApplicantTagActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchApplicantTagActivitiesQuery,
        FetchApplicantTagActivitiesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchApplicantTagActivitiesQuery | undefined,
  FetchApplicantTagActivitiesQueryVariables
>;
export function useFetchApplicantTagActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchApplicantTagActivitiesQuery,
        FetchApplicantTagActivitiesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchApplicantTagActivitiesQuery,
    FetchApplicantTagActivitiesQueryVariables
  >(FetchApplicantTagActivitiesDocument, options);
}
export type FetchApplicantTagActivitiesQueryHookResult = ReturnType<
  typeof useFetchApplicantTagActivitiesQuery
>;
export type FetchApplicantTagActivitiesLazyQueryHookResult = ReturnType<
  typeof useFetchApplicantTagActivitiesLazyQuery
>;
export type FetchApplicantTagActivitiesSuspenseQueryHookResult = ReturnType<
  typeof useFetchApplicantTagActivitiesSuspenseQuery
>;
export type FetchApplicantTagActivitiesQueryResult = Apollo.QueryResult<
  FetchApplicantTagActivitiesQuery,
  FetchApplicantTagActivitiesQueryVariables
>;
export const FetchOrganisationTagsDocument = gql`
  query FetchOrganisationTags {
    organisationTags {
      id
      label
      tagCategory
      assignedCount
    }
  }
`;

/**
 * __useFetchOrganisationTagsQuery__
 *
 * To run a query within a React component, call `useFetchOrganisationTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchOrganisationTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchOrganisationTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchOrganisationTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FetchOrganisationTagsQuery,
    FetchOrganisationTagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FetchOrganisationTagsQuery,
    FetchOrganisationTagsQueryVariables
  >(FetchOrganisationTagsDocument, options);
}
export function useFetchOrganisationTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FetchOrganisationTagsQuery,
    FetchOrganisationTagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FetchOrganisationTagsQuery,
    FetchOrganisationTagsQueryVariables
  >(FetchOrganisationTagsDocument, options);
}
// @ts-ignore
export function useFetchOrganisationTagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FetchOrganisationTagsQuery,
    FetchOrganisationTagsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  FetchOrganisationTagsQuery,
  FetchOrganisationTagsQueryVariables
>;
export function useFetchOrganisationTagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchOrganisationTagsQuery,
        FetchOrganisationTagsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  FetchOrganisationTagsQuery | undefined,
  FetchOrganisationTagsQueryVariables
>;
export function useFetchOrganisationTagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FetchOrganisationTagsQuery,
        FetchOrganisationTagsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    FetchOrganisationTagsQuery,
    FetchOrganisationTagsQueryVariables
  >(FetchOrganisationTagsDocument, options);
}
export type FetchOrganisationTagsQueryHookResult = ReturnType<
  typeof useFetchOrganisationTagsQuery
>;
export type FetchOrganisationTagsLazyQueryHookResult = ReturnType<
  typeof useFetchOrganisationTagsLazyQuery
>;
export type FetchOrganisationTagsSuspenseQueryHookResult = ReturnType<
  typeof useFetchOrganisationTagsSuspenseQuery
>;
export type FetchOrganisationTagsQueryResult = Apollo.QueryResult<
  FetchOrganisationTagsQuery,
  FetchOrganisationTagsQueryVariables
>;
export const SystemTagActivitySetDocument = gql`
  mutation systemTagActivitySet($input: SystemTagActivityInput!) {
    systemTagActivitySet(input: $input) {
      tagActivity {
        id
        tag {
          ... on SystemTag {
            id
            label
          }
        }
        targetApplicant {
          listingId
          candidateId
        }
        action
        actionedByUser {
          ...TagActivityActionedByUserFields
        }
      }
      errors {
        message
      }
    }
  }
  ${TagActivityActionedByUserFieldsFragmentDoc}
`;
export type SystemTagActivitySetMutationFn = Apollo.MutationFunction<
  SystemTagActivitySetMutation,
  SystemTagActivitySetMutationVariables
>;

/**
 * __useSystemTagActivitySetMutation__
 *
 * To run a mutation, you first call `useSystemTagActivitySetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemTagActivitySetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemTagActivitySetMutation, { data, loading, error }] = useSystemTagActivitySetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSystemTagActivitySetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SystemTagActivitySetMutation,
    SystemTagActivitySetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SystemTagActivitySetMutation,
    SystemTagActivitySetMutationVariables
  >(SystemTagActivitySetDocument, options);
}
export type SystemTagActivitySetMutationHookResult = ReturnType<
  typeof useSystemTagActivitySetMutation
>;
export type SystemTagActivitySetMutationResult =
  Apollo.MutationResult<SystemTagActivitySetMutation>;
export type SystemTagActivitySetMutationOptions = Apollo.BaseMutationOptions<
  SystemTagActivitySetMutation,
  SystemTagActivitySetMutationVariables
>;
export const OrganisationTagCreateDocument = gql`
  mutation OrganisationTagCreate($input: OrganisationTagCreateInput!) {
    organisationTagCreate(input: $input) {
      tag {
        __typename
        ... on OrganisationTag {
          id
          label
        }
      }
      errors {
        message
        code
      }
    }
  }
`;
export type OrganisationTagCreateMutationFn = Apollo.MutationFunction<
  OrganisationTagCreateMutation,
  OrganisationTagCreateMutationVariables
>;

/**
 * __useOrganisationTagCreateMutation__
 *
 * To run a mutation, you first call `useOrganisationTagCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTagCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationTagCreateMutation, { data, loading, error }] = useOrganisationTagCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationTagCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OrganisationTagCreateMutation,
    OrganisationTagCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    OrganisationTagCreateMutation,
    OrganisationTagCreateMutationVariables
  >(OrganisationTagCreateDocument, options);
}
export type OrganisationTagCreateMutationHookResult = ReturnType<
  typeof useOrganisationTagCreateMutation
>;
export type OrganisationTagCreateMutationResult =
  Apollo.MutationResult<OrganisationTagCreateMutation>;
export type OrganisationTagCreateMutationOptions = Apollo.BaseMutationOptions<
  OrganisationTagCreateMutation,
  OrganisationTagCreateMutationVariables
>;
export const OrganisationTagActivitySetDocument = gql`
  mutation OrganisationTagActivitySet($input: OrganisationTagActivityInput!) {
    organisationTagActivitySet(input: $input) {
      tagActivities {
        id
        tag {
          ... on SystemTag {
            id
            label
          }
          ... on OrganisationTag {
            id
            label
          }
        }
        targetApplicant {
          listingId
          candidateId
        }
        notes
        action
        actionedByUser {
          ...TagActivityActionedByUserFields
        }
      }
      errors {
        message
      }
    }
  }
  ${TagActivityActionedByUserFieldsFragmentDoc}
`;
export type OrganisationTagActivitySetMutationFn = Apollo.MutationFunction<
  OrganisationTagActivitySetMutation,
  OrganisationTagActivitySetMutationVariables
>;

/**
 * __useOrganisationTagActivitySetMutation__
 *
 * To run a mutation, you first call `useOrganisationTagActivitySetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTagActivitySetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationTagActivitySetMutation, { data, loading, error }] = useOrganisationTagActivitySetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationTagActivitySetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OrganisationTagActivitySetMutation,
    OrganisationTagActivitySetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    OrganisationTagActivitySetMutation,
    OrganisationTagActivitySetMutationVariables
  >(OrganisationTagActivitySetDocument, options);
}
export type OrganisationTagActivitySetMutationHookResult = ReturnType<
  typeof useOrganisationTagActivitySetMutation
>;
export type OrganisationTagActivitySetMutationResult =
  Apollo.MutationResult<OrganisationTagActivitySetMutation>;
export type OrganisationTagActivitySetMutationOptions =
  Apollo.BaseMutationOptions<
    OrganisationTagActivitySetMutation,
    OrganisationTagActivitySetMutationVariables
  >;
export const DeleteOrganisationTagDocument = gql`
  mutation DeleteOrganisationTag($input: DeleteOrganisationTagInput!) {
    deleteOrganisationTag(input: $input) {
      tag {
        __typename
        ... on OrganisationTag {
          id
          label
        }
      }
      errors {
        message
      }
    }
  }
`;
export type DeleteOrganisationTagMutationFn = Apollo.MutationFunction<
  DeleteOrganisationTagMutation,
  DeleteOrganisationTagMutationVariables
>;

/**
 * __useDeleteOrganisationTagMutation__
 *
 * To run a mutation, you first call `useDeleteOrganisationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganisationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganisationTagMutation, { data, loading, error }] = useDeleteOrganisationTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganisationTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteOrganisationTagMutation,
    DeleteOrganisationTagMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteOrganisationTagMutation,
    DeleteOrganisationTagMutationVariables
  >(DeleteOrganisationTagDocument, options);
}
export type DeleteOrganisationTagMutationHookResult = ReturnType<
  typeof useDeleteOrganisationTagMutation
>;
export type DeleteOrganisationTagMutationResult =
  Apollo.MutationResult<DeleteOrganisationTagMutation>;
export type DeleteOrganisationTagMutationOptions = Apollo.BaseMutationOptions<
  DeleteOrganisationTagMutation,
  DeleteOrganisationTagMutationVariables
>;
export const GetHirePipelineTagActivitiesDocument = gql`
  query GetHirePipelineTagActivities($listingIds: [ID!]) {
    tagActivities(filter: { listingIds: $listingIds, category: ACTIVITY }) {
      id
      action
      targetApplicant {
        id
        candidateId
        listingId
        name
      }
      tag {
        ... on SystemTag {
          id
          label
        }
        ... on OrganisationTag {
          id
          label
        }
      }
    }
  }
`;

/**
 * __useGetHirePipelineTagActivitiesQuery__
 *
 * To run a query within a React component, call `useGetHirePipelineTagActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHirePipelineTagActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHirePipelineTagActivitiesQuery({
 *   variables: {
 *      listingIds: // value for 'listingIds'
 *   },
 * });
 */
export function useGetHirePipelineTagActivitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetHirePipelineTagActivitiesQuery,
    GetHirePipelineTagActivitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetHirePipelineTagActivitiesQuery,
    GetHirePipelineTagActivitiesQueryVariables
  >(GetHirePipelineTagActivitiesDocument, options);
}
export function useGetHirePipelineTagActivitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHirePipelineTagActivitiesQuery,
    GetHirePipelineTagActivitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetHirePipelineTagActivitiesQuery,
    GetHirePipelineTagActivitiesQueryVariables
  >(GetHirePipelineTagActivitiesDocument, options);
}
// @ts-ignore
export function useGetHirePipelineTagActivitiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetHirePipelineTagActivitiesQuery,
    GetHirePipelineTagActivitiesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetHirePipelineTagActivitiesQuery,
  GetHirePipelineTagActivitiesQueryVariables
>;
export function useGetHirePipelineTagActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetHirePipelineTagActivitiesQuery,
        GetHirePipelineTagActivitiesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetHirePipelineTagActivitiesQuery | undefined,
  GetHirePipelineTagActivitiesQueryVariables
>;
export function useGetHirePipelineTagActivitiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetHirePipelineTagActivitiesQuery,
        GetHirePipelineTagActivitiesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetHirePipelineTagActivitiesQuery,
    GetHirePipelineTagActivitiesQueryVariables
  >(GetHirePipelineTagActivitiesDocument, options);
}
export type GetHirePipelineTagActivitiesQueryHookResult = ReturnType<
  typeof useGetHirePipelineTagActivitiesQuery
>;
export type GetHirePipelineTagActivitiesLazyQueryHookResult = ReturnType<
  typeof useGetHirePipelineTagActivitiesLazyQuery
>;
export type GetHirePipelineTagActivitiesSuspenseQueryHookResult = ReturnType<
  typeof useGetHirePipelineTagActivitiesSuspenseQuery
>;
export type GetHirePipelineTagActivitiesQueryResult = Apollo.QueryResult<
  GetHirePipelineTagActivitiesQuery,
  GetHirePipelineTagActivitiesQueryVariables
>;
export const GetTeamMembersDocument = gql`
  query GetTeamMembers($pagination: Pagination) {
    teams(pagination: $pagination) {
      items {
        id
        name
        members {
          employer {
            id
            firstName
            lastName
          }
        }
      }
      pageInfo {
        totalPages
      }
    }
  }
`;

/**
 * __useGetTeamMembersQuery__
 *
 * To run a query within a React component, call `useGetTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamMembersQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetTeamMembersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTeamMembersQuery,
    GetTeamMembersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTeamMembersQuery, GetTeamMembersQueryVariables>(
    GetTeamMembersDocument,
    options,
  );
}
export function useGetTeamMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTeamMembersQuery,
    GetTeamMembersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTeamMembersQuery, GetTeamMembersQueryVariables>(
    GetTeamMembersDocument,
    options,
  );
}
// @ts-ignore
export function useGetTeamMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTeamMembersQuery,
    GetTeamMembersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetTeamMembersQuery,
  GetTeamMembersQueryVariables
>;
export function useGetTeamMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTeamMembersQuery,
        GetTeamMembersQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetTeamMembersQuery | undefined,
  GetTeamMembersQueryVariables
>;
export function useGetTeamMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTeamMembersQuery,
        GetTeamMembersQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTeamMembersQuery,
    GetTeamMembersQueryVariables
  >(GetTeamMembersDocument, options);
}
export type GetTeamMembersQueryHookResult = ReturnType<
  typeof useGetTeamMembersQuery
>;
export type GetTeamMembersLazyQueryHookResult = ReturnType<
  typeof useGetTeamMembersLazyQuery
>;
export type GetTeamMembersSuspenseQueryHookResult = ReturnType<
  typeof useGetTeamMembersSuspenseQuery
>;
export type GetTeamMembersQueryResult = Apollo.QueryResult<
  GetTeamMembersQuery,
  GetTeamMembersQueryVariables
>;
export const CreateUploadRequestDocument = gql`
  mutation CreateUploadRequest($input: CreateUploadRequestInput!) {
    createUploadRequest(input: $input) {
      id
      uploadUrl
      downloadUrl
    }
  }
`;
export type CreateUploadRequestMutationFn = Apollo.MutationFunction<
  CreateUploadRequestMutation,
  CreateUploadRequestMutationVariables
>;

/**
 * __useCreateUploadRequestMutation__
 *
 * To run a mutation, you first call `useCreateUploadRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUploadRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUploadRequestMutation, { data, loading, error }] = useCreateUploadRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUploadRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUploadRequestMutation,
    CreateUploadRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateUploadRequestMutation,
    CreateUploadRequestMutationVariables
  >(CreateUploadRequestDocument, options);
}
export type CreateUploadRequestMutationHookResult = ReturnType<
  typeof useCreateUploadRequestMutation
>;
export type CreateUploadRequestMutationResult =
  Apollo.MutationResult<CreateUploadRequestMutation>;
export type CreateUploadRequestMutationOptions = Apollo.BaseMutationOptions<
  CreateUploadRequestMutation,
  CreateUploadRequestMutationVariables
>;
